export default {
    "label.update_translations_unsuccessful": "{count} öğe başarısız oldu:",
    "global.no_records": "Kayıt yok",
    "notifications.rp_has_been_updated": "Toplumsal Uyum Projesi güncellendi",
    "moduleTitle.files": "Dosyalar",
    "label.coordinator": "Ödül Koordinatörü",
    "sidebar.translations_managment": "Çeviri Yönetimi ",
    "table.file": "Dosya",
    "label.report_overview": "Genel bakış",
    "label.parent_agreement": "Yazdırılabilir Ebeveyn Onay Formu",
    "parentalConsent.i_consent_to_and_understand_that": "6. Ödül Programı kapsamında yapılan faaliyetlerin resimlerinin çekilebileceğini; bu resimlerin tanıtım amacı ile ebeveyn ve katılımcı tarafından imzalanan onay formu ile kullanılabilineceğini biliyorum ve bunu onaylıyorum. ",
    "parentalConsent.i_understand_that_participants_are_required_to_comply": "12. Katılımcıların Online Record Book'ta bulunan Ödül kapsamındaki kurallara, gerekliliklere, ilkelere ve davranış biçimlerine; Ödül Merkezi'nin belirlediği Acil Durum Planına, Macera ve Keşif Yolculuğu kurallarına uygun olarak hareket etmesi gerektiğini ve davranışlarının yukarıda belirlenen standartlara uygun olmaması takdirde Ödülünün onaylanamayacağını anlıyorum.",
    "table.end_date": "Bitiş Tarihi",
    "label.activation_date": "Aktivasyon Tarihi",
    "label.report": "Rapor",
    "label.award_is_offline": "Ödül çevrimdışı",
    "label.pending_changes": "Değişiklikler yapılıyor...",
    "errors.min_nights_required": "En az {nights} gece sayısı gereklidir",
    "label.country": "Ülke",
    "notifications.award_leader_has_been_returned": "Ödül Lideri onaylanmadan geri gönderildi",
    "notifications.participant_has_been_updated": "Katılımcı güncellendi",
    "label.phone_number": "Telefon Numarası",
    "roles.aj_assessor": "Macera ve Keşif Yolculuğu Assessor / Denetmen",
    "notifications.person_state_has_been_changed": "Kişinin durumu değiştirildi",
    "pageTitle.dashboard": "Pano",
    "moduleTitle.global_payment_method": "Global ödeme yöntemi ",
    "label.organization_type": "Kurum Türü",
    "button.account_settings": "Hesap Ayarları",
    "notifications.contact_has_been_updated": "Kişi bilgisi güncellendi",
    "participant.recover_password": "Şifreyi Yenile",
    "notifications.assessment_request_has_been_sent": "Değerlendirme isteği gönderildi",
    "button.unassign": "Atamayı kaldır",
    "label.start_date": "Başlangıç Tarihi",
    "label.assign_labels": "",
    "sidebar.participants": "Katılımcılar",
    "roles.coordinator": "Ödül Koordinatörü",
    "label.organization_contact": "Kurum İletişim Bilgileri",
    "tabs.customization": "Kişiselleştirme",
    "sidebar.award_units": "Ödül Merkezleri",
    "button.change_goal": "Hedef Değiştir ",
    "translationsManagement.selectProject": "Proje seçin",
    "award.rp": "Toplumsal Uyum Projesi",
    "label.size": "Boyut",
    "label.bulk_action_results": "Toplu İşlem sonucu",
    "notifications.activity_has_been_approved": "Faaliyet onaylandı",
    "label.payment_type": "Ödeme türü",
    "button.gop_assignment": "",
    "button.resend_assessment_request": "Değerlendirme isteğini tekrar gönderin",
    "notifications.template_has_been_removed": "Şablon kaldırıldı",
    "button.award_settings": "Ödül Ayarları",
    "pageTitle.payment": "Ödeme",
    "tasks.return_award": "Ödülü Onaylanmadan Geri Gönder",
    "label.link": "link",
    "moduleTitle.award_participant_delete": "Bir Ödül Seviyesini sil",
    "pageTitle.mro_related_contacts": "EMAS Ofis- Kişiler",
    "pageTitle.my_organization_labels": "",
    "tabs.activity_signoff": "Bölüm Bitirme Onayı",
    "table.logs": "Faaliyet Kayıtları",
    "moduleTitle.remove_file": "Dosyayı sil?",
    "label.email_confirmed": "Email Onaylandı",
    "notifications.activity_has_been_returned": "Faaliyet onaylanmadan geri gönderildi",
    "label.note": "Not",
    "button.show": "Göster",
    "tabs.adventurous_journey": "Macera ve Keşif Yolculuğu",
    "sidebar.my_todolist": "Yapılacaklar",
    "label.here": "Buraya",
    "organisation.change_award_mode": "Ödüllerin işlevini/biçimini değiştir",
    "table.note_from_al": "Ödül Liderinden Not ",
    "label.gender": "Cinsiyet",
    "moduleTitle.remove": "Kaldır?",
    "errors.must_be_less_than": "daha az olmalıdır {limit}",
    "button.logout": "Çıkış",
    "label.no_selected_participants": "Hiç katılımcı seçilmedi",
    "button.new_aj_event": "Yeni Macera ve Keşif Etkinliği",
    "label.employement_status": "Çalışma Durumu",
    "tabs.logs": "Faaliyet Kayıtları",
    "tabs.contacts": "Kişiler",
    "label.option": "Seçenek",
    "dashboard.charts": "Tablolar",
    "notifications.rp_has_been_approved": "Toplumsal Uyum Projesi onaylandı",
    "pageTitle.new_participant": "Yeni Katılımcı",
    "notifications.award_leader_has_been_approved": "Ödül Lideri onaylandı",
    "moduleTitle.would_you_like_to_remove_leader_training": "Ödül Liderlerinin eğitimini silmek ister misiniz?",
    "moduleTitle.update_configuration_value": "Yapılandırma değerini güncelle",
    "table.description": "Açıklama",
    "table.organization": "Kurum",
    "label.youtube": "YouTube",
    "label.author": "Düzenleyen",
    "table.suitable_for_award_level": "Uygun Kategori:",
    "label.content_update": "Lütfen bekleyiniz. Güncelleniyor...",
    "notifications.new_question_has_been_added": "Yeni soru eklendi",
    "pageTitle.nao_awards": "Ulusal Ofis-Ödüller",
    "table.last_name": "Soyad",
    "moduleTitle.adventurous_journey_detail": "Keşif Detayları",
    "Description of the combo box selection in bulk operation panel": {"label.bulk_operations": "Toplu eylem"},
    "label.project_location_type": "Proje Konumunun Türü",
    "label.email_help_award_level": "Ödül Seviyesi",
    "label.date": "Tarih",
    "label.previous_completed_award_place": "Nerede?",
    "button.show_more": "Daha fazla göster",
    "label.wwc_number": "''Çocuklar ile Çalışma Kontrolü'' numarası",
    "button.filter": "Filtrele",
    "notifications.rp_has_been_returned": "Toplumsal Uyum Projesi onaylanmadan geri gönderildi",
    "pageTitle.residetial_project_assessor_report": "Toplumsal Uyum Projesi-Danışman Raporu",
    "label.generating": "Yaratılıyor...",
    "moduleTitle.finance_system_data": "Finans Sistemi Verisi",
    "notifications.adventurous_journey_state_has_been_changed": "Macera ve Keşif Yolculuğu durumu değiştirildi",
    "route.levels": "Kategoriler",
    "moduleTitle.activity_leader": "Danışman",
    "tasks.approve_event": "Etkinliği Onayla",
    "tasks.reject_event": "Etkinliği Gözden Geçir",
    "table.region": "Bölge",
    "pageTitle.nao_award_leaders": "Ulusal Ofis- Ödül Liderleri",
    "errors.must_be_at_least": "En az karakter sayısı:",
    "table.title": "Ünvan",
    "table.last_activity": "Son Faaliyet",
    "tasks.delete_registration": "Kaydı Sil",
    "table.date_time": "Tarih/Zaman",
    "parentalConsent.the_award_operators_are_committed_to_respecting": "14. Tüm Ödül Otoriteleri bilgilerinizin gizliliğine önem vermektedir. Bu formda alınan kişisel bilgiler katılımcının Ödül Programı'na katılımı içindir. Bu bilgileri doldurmayan ya da bu bilgileri bulunmayan katılımcılar Ödül Programı'na kayıt olamazlar (bu durum bilgilerini daha önce vermiş katılımcılar için geçerli değildir). Sizin kişisel bilgilerinizi, size fayda sağlayacağını düşündüğümüz Ödül Faaliyetleri ve etkinliklerinden haberdar etmek için kullanabiliriz. Kişisel bilgilerinizi, Ödül Programı'nın yönetilmesinde veya uygulanmasında rol alan ulusal veya uluslarası kuruluşlarla paylaşabiliriz. Kişisel bilgilerinize ulaşmak isterseniz lütfen Ulusal Otorite ile irtibata geçiniz. Ödül Otoritenizle, gizlilik anlaşmasının bir kopyasını almak için iletişime geçebilirsiniz. ",
    "aj.practice_journey": "Deneme Yolculuğu",
    "notification.log_has_been_restored": "Faaliyet kaydı yenilendi",
    "tabs.my_participants": "Katılımcılarım",
    "label.bulk_action_assign_label": "",
    "moduleTitle.supervisor": "Supervisor / Gözetmen",
    "moduleTitle.your_parental_consent": "Ebeveyn Onayınız",
    "route.registration_participants": "Katılımcı Kayıtları",
    "placeholder.start_typing": "Yazmaya başlayın...",
    "tasks.approve_award": "Ödülü Onayla",
    "route.registrations": "Kayıtlar",
    "button.add_activity": "Aktivite ekle",
    "notifications.aj_event_has_been_created": "Macera ve Keşif Yolculuğu oluşturuldu",
    "states.supervisor_approval": "Danışman Onayı",
    "label.description": "Açıklama",
    "button.leave_anyway": "Yine de Çıkış Yap",
    "tabs.registrations": "Kayıtlar",
    "states.leader_signoff": "",
    "moduleTitle.forbidden": "Yasak",
    "notifications.translations_has_been_updated.button": "Bildirim çevirileri güncelleme düğmesi",
    "pageTitle.nao_registration": "Ulusal Ofis-Kayıt",
    "pageTitle.mro_logs": "EMAS Ofis- Faaliyet Kayıtları",
    "meta.page_not_found": "Sayfa Bulunamadı",
    "label.bulk_action_unsuccessful": "{count} başarısız:",
    "global.days": "gün",
    "table.review": "Gözden geçir",
    "table.as_assessor_for": "Danışmanlık alanı:",
    "roles.if_staff_statistical_user": "Uluslararası Ödül Vakfı İstatiksel Kullanıcı",
    "table.levels": "Kategoriler",
    "label.suitable_for_level": "Ödül Kategorisi:",
    "pageTitle.leaders": "Ödül Liderleri",
    "moduleTitle.send_test_email": "Deneme emaili gönder",
    "pageTitle.tasks_removed_registration": "Kaldırılan Katılımcı Kayıtları",
    "label.you_will_be_forced_to_login_again_after_change": "Değişimden sonra yeniden giriş yapmanız gerekecek.",
    "table.recent_updates": "Notlar ve son güncellemeler",
    "pageTitle.tasks_activity_signoffs": "Bölüm Bitirme Onayı",
    "pageTitle.payments": "Ödemeler",
    "global.nights": "gece",
    "label.blank_any_level": "her düzeyde BOŞ",
    "button.view_section": "Bölümü görüntüle",
    "moduleTitle.select_organization": "Kurum Seç ",
    "pageTitle.manual_data_import": "Manuel veri içe aktarma",
    "button.upload_files": "Dosyalar yükle",
    "label.migrated_contact_email": "Taşınan email adresi",
    "label.for_award_unit": "Ödül Merkezi için",
    "label.aj_template_note": "Şablon notu",
    "table.last_log_added": "Son Kayıt",
    "button.view_participant": "Katılımcıdan",
    "label.please_comment_on_the_participants": "Lütfen katılımcının gelişimi/performansı/özverisi üzerine yorum yapınız",
    "label.consent_already_given_login": "Onay zaten verildi. Lütfen velisi olduğunuz katılımcı gibi giriş yapınız.",
    "participant.level_start_date": "{value} Başlangıç Tarihi",
    "sidebar.my_region_office": "EMAS Ofis",
    "states.section_signoff": "Bölüm Bitirme Onayı",
    "moduleTitle.assessor_details": "Danışman bilgileri",
    "moduleTitle.adventurous_journey_settings": "Macera ve Keşif Yolculuğu Ayarları",
    "moduleTitle.note_from_al": "Ödül Liderinden not ",
    "button.add_role": "Görev Ekle",
    "table.run": "Çalıştır",
    "states.change_to_state_warning_missing_assessment": "UYARI: Değerlendirme eklenmemiştir. Hala devam etmek istiyor musunuz?",
    "label.user_app_guide_leader": "Uygulama Kullanım Kılavuzu - Ödül Lideri",
    "tabs.section_approval": "Bölüm Onayı",
    "roles.award_verifier": "Ödülü Doğrulayan Kişi",
    "tabs.activity_approval": "Faaliyet Onayı",
    "logs.add_log": "Faaliyet kaydı ekle",
    "tabs.award": "Ödül",
    "notifications.this_role_has_read_only_persmission": "Bu görev salt okunur izne sahiptir.",
    "table.no_filtered_results": "Filtrelenmemiş Sonuçlar",
    "button.praise": "Yorum",
    "label.prevent_welcome_email_assessor": "Değerlendiriciye karşılama e-postası göndermeyin",
    "label.location_detail": "Konum Detayları",
    "label.optional": "(opsiyonel)",
    "errors.do_not_match": "Eşleşmiyor",
    "label.use_comma_for_multiple_entries": "Çoklu girişler için virgül kullanınız",
    "label.operating_authority": "Operasyon Otorite Birimi",
    "label.activity_section": "Faaliyet Bölümü",
    "notifications.you_have_been_logged_out": "Çıkış yaptınız",
    "table.finished": "Bitti",
    "button.same_as_billing": "Faturalandırma ile aynı",
    "table.payment": "Ödeme",
    "table.current_level": "Güncel Kategori",
    "button.view_nao": "Ödül Ofisi tarafından iade edilir (revizyon notu ile birlikte)",
    "table.email_confirmation": "Email Onayı",
    "moduleTitle.shipping_address": "Teslimat Adresi",
    "label.secondary_phone_type": "İkincil telefon türü",
    "notifications.saved": "Kaydedildi",
    "pageTitle.all_participants": "Tüm Katılımcılar",
    "label.first_name": "Ad",
    "label.oa_price": "Operasyon Otorite Birimi bağış tutarı",
    "table.award_mode": "Ödül durumu",
    "tabs.api_keys": "",
    "award.award_detail": "Ödül Detayları ",
    "tabs.user_management": "Kullanıcı Yönetimi",
    "tabs.all_events": "Tüm Etkinlikler",
    "notifications.history_record_has_been_removed": "Ödül deneyimi kaydı kaldırılmıştır ",
    "award.no_data": "Veri Yok",
    "notifications.preparation_training_has_been_added": "Hazırlık ve Eğitim Eklendi",
    "label.message": "Mesaj",
    "notifications.participant_info_updated": "Katılımcı bilgisi güncellendi",
    "roles.nao_staff": "Ulusal Ödül Otoritesi Personeli",
    "tabs.adventurous_journeys": "Macera ve Keşif Yolculukları",
    "label.gops": "Global Operasyon Ortakları",
    "route.upload": "Yükle",
    "notifications.history_record_has_been_added": "Ödül Deneyimi kaydı eklenmiştir",
    "notifications.history_record_has_been_updated": "Ödül deneyimi kaydı güncellenmiştir",
    "label.no_data": "Veri yok",
    "button.add_coordinator": "Ödül Koordinatörü ekle",
    "label.you_are_already_logged_as": "Zaten giriş yaptınız ",
    "route.my_national_office": "Ulusal Ofisim",
    "tabs.leaders": "Ödül Liderleri",
    "label.email_confirmation": "Email Onayı",
    "table.registration_date": "Kayıt Tarihi",
    "notifications.role_has_been_removed": "Görev kaldırıldı",
    "button.move": "Taşı",
    "label.terms_and_conditions": "Şartlar ve koşullar",
    "pageTitle.detail": "Detaylar",
    "table.award_unit": "Ödül Merkezi",
    "sidebar.settings": "Ayarlar",
    "dashboard.leader_state": "Ödül Liderleri- Şehre Göre",
    "notifications.award_unit_has_been_approved": "Ödül Lideri onaylandı",
    "states.awaiting_approval": "Onay bekleniyor",
    "table.level": "Kategori",
    "table.action_requested": "İşlem talep edildi",
    "label.organisation_mode": "Kurum biçimi/işlevi",
    "label.no_note": "Not yok",
    "tabs.my_events": "Etkinliklerim",
    "notifications.participants_have_been_added": "Katılımcılar eklendi",
    "tabs.registration_questions": "Kayıt Soruları",
    "button.delete_registration": "Kaydı Sil",
    "notifications.parental_consent_link_has_been_sent": "Ebeveyn Onayı linki gönderildi",
    "moduleTitle.select_role_organization": "Görev & Kurum seçiniz",
    "label.experience": "Deneyim",
    "translationsManagement.modal.title": "Çeviriler Yönetim kalıcı başlığı",
    "table.ic": "Bağımsız Ülke ",
    "table.id": "No/ID",
    "label.notify_email_explanation": "Katılımcıya, değerlendirme talebinin teslim edilmediği e-posta ile bildirilecektir. Kendilerinden e-posta adresini düzeltmeleri ve değerlendirme talebini tekrar göndermeleri istenecektir.",
    "participant.would_you_like_to_remove": "Bu hesabı silmek istiyor musunuz?",
    "table.fields_included": "Dahil edilen alanlar",
    "label.user_guide_web_leader": "Web Kullanıcı Kılavuzu - Ödül Lideri",
    "label.journey_type": "Yolculuk Türü",
    "button.setup": "Planla ",
    "tabs.my_national_office": "Ulusal Ofisim",
    "notifications.training_has_been_removed": "Eğitim taşındı",
    "label.nominated_and_identified_persons": "Yetkili kişiler, tüm datayı görüntüleyebilir fakat düzenleme yapamazlar.",
    "moduleTitle.you_have_been_logged_out_due_to_inactivity": "Bir işlem yapmadığınız için sistemden çıkış yapıldı",
    "states.award_leader_signoff": "Bitirme Onayı (Ödül Lideri)",
    "table.award_signoff_attempts": "Ödül bitirme onayı verme denemeleri",
    "sidebar.regions": "Bölgeler",
    "label.activity_deleted_note": "Bu faaliyet silinmiştir. Alttaki tuşa basarak yenileyebilirsiniz.",
    "table.total": "Toplam",
    "errors.a_problem_has_occured_during_processing": "İşlem sırasında bir sorun oluştu, daha fazla bilgi için bkz.",
    "participant.participant_already_has_gold_award": "Katılımcı zaten Altın Ödül sahibi",
    "pageTitle.mro": "EMAS Ofis",
    "notifications.authorization_code_has_expired": "Yetki kodunun süresi dolmuştur",
    "moduleTitle.child_organization_labels": "Alt Kuruluş Etiketleri",
    "aj.aj_events": "Macera ve Keşif Yolculuğu Etkinlikleri",
    "global.loading": "Yükleniyor",
    "label.gnipp": "GNIPP",
    "sidebar.registrations": "Kayıtlar",
    "label.any_string": "Herhangi bir seri",
    "contact.change_contact_status": "İletişim Kişisinin durumunu değiştir",
    "tabs.registration": "Kayıt",
    "label.override_payment_note": "Geçersiz ödeme notu",
    "notifications.section_has_been_signed_off": "Bölüm Bitirildi",
    "label.payment_date": "Ödeme Tarihi",
    "button.approve": "Onayla",
    "moduleTitle.loggin_in": "Giriş yapılıyor",
    "label.website": "Websitesi",
    "label.role": "Rol",
    "table.assessor_report": "Danışman Raporu",
    "label.ue_fe": "Kullanıcı Etkileşimi Ön Uç (Katılımcı web statik etiketleri)",
    "label.please_comment_on_the_participants_effort": "",
    "label.previously_worked_as_assessor": "Assessor/Danışman deneyimi mevcut",
    "pageTitle.registrations": "Kayıtlar",
    "parentalConsent.this_form_must_be_completed": "Bu form <strong>must</strong> 18 yaşın altındaki katılımcılar için ebeveynleri tarafından doldurulmalıdır.",
    "button.apply": "Uygula",
    "errors.include_at_least_one_number": "En az bir rakam bulunmalı",
    "label.content_restore": "Yenileniyor...",
    "logs.hour": "saat",
    "parentalConsent.i_have_read_and_understand": "7. Ödül Koşulları belgesinde, Ödül Programı ile iligli olan çeşitli gereklilikleri ve çeşitli Ödül kategorilerini bildiren bölümü (5. sayfada), okudum ve anlıyorum. ",
    "notifications.award_was_deleted": "Ödül silindi.",
    "label.journey_category": "Yolculuk Kategorisi",
    "notifications.search_cancelled": "Arama kesintiye uğradı, aramanın bitirilmesi için beklemelisiniz.",
    "route.detail": "Detaylar",
    "route.user_guide": "Kullanıcı Kılavuzu",
    "moduleTitle.history": "Ödül Deneyimi",
    "table.gop_name": "",
    "pageTitle.tasks_unassigned_participants": "Atanmamış Katılımcılar",
    "states.inactive": "Pasif",
    "pageTitle.search_results": "Arama Sonuçları",
    "button.proceed_to_login": "Giriş Yapmak İçin İlerleyin",
    "pageTitle.assessor_report_reject": "Danışman Raporu onaylanmadan gözden geçirildi",
    "notifications.contact_has_been_removed": "Kişi kaldırıldı",
    "sidebar.operating_authorities": "Operasyon Otorite Birimleri",
    "label.no_note_from_participant": "Katılımcıdan not yok",
    "aj.preparation_and_training": "Hazırlık ve Eğitim",
    "route.user_guide_web_leader": "Web Kullanıcı Kılavuzu - Ödül Lideri",
    "label.position_in_organization": "Kurumdaki Pozisyonu",
    "errors.emails_dont_match": "Email adresleri eşleşmiyor",
    "route.my_participants": "Katılımcılarım",
    "pageTitle.customisations": "Kişiselleştirmeler",
    "tabs.localization_files": "Yazılım Dosyaları",
    "table.assessor_approval": "Assessor/Denetmen Onayı",
    "tabs.related_contacts": "İlgili Kişiler",
    "table.aus": "Ödül Merkezleri",
    "table.category": "Kategori",
    "errors.file_is_too_large": "Maksimum yükleme boyutu 20MB",
    "label.possible_values": "Olası değerler:",
    "label.if_your_download_doesnt_start": "İndirme otomatik olarak başlamıyorsa lütfen tıklayınız",
    "route.independent_award_centres": "Bağımsız Ödül Merkezleri",
    "pageTitle.user_guide": "Kullanıcı Kılavuzu",
    "button.visit": "Ziyaret et",
    "label.hours_first_letter": "sa",
    "pageTitle.my_organization_detail": "Kurumum - Bilgiler ",
    "pageTitle.nao_detail": "Ulusal Ofis-Detaylar",
    "button.change": "Değiştir",
    "award.aj": "Macera ve Keşif Yolculuğu",
    "table.award_state": "Ödül durumu",
    "pageTitle.tasks_award_signoff": "Ödül Tamamlama Onayı",
    "pageTitle.regions": "Bölgeler",
    "notifications.award_has_been_signed_off": "Ödül tamamlandı",
    "dashboard.award_approved_by": "Onaylanan Ödüller- 2016'daki kategorilere göre",
    "tabs.new_template": "Yeni Şablon",
    "error.parent_email_must_be_filled": "Ebeveyn email adresi kaydedilmelidir",
    "label.organisation_invoicing_name": "Kurum Faturalama Adı",
    "pageTitle.related_contacts": "İlgili Kişiler ",
    "button.try_again": "Lütfen kapatıp tekrar deneyiniz",
    "label.cannot_be_change_to_another": "Başka Ödül kategorisine geçiş yapılamamaktadır",
    "notifications.lead_coordinator_has_been_set": "Yeni Ödül Merkezi Koordinatörü belirlendi",
    "label.training_name": "Eğitim İsmi",
    "moduleTitle.new_contact": "Yeni Kişi",
    "translationsManagement.modal.updateTitle": "Çeviriler Yönetim modu güncellemesi",
    "moduleTitle.offline_award_units_signoff": "Çevrimdışı Ödül Lideri ayrıldı",
    "notifications.award_level_has_been_changed": "Ödül Kategorisi değiştirildi",
    "label.subject": "Konu",
    "route.silver_level": "Gümüş Kategorisi",
    "label.privacy_notice": "Veri Gizliliği Bildirimi",
    "label.switch_organization": "Kurum Değiştir",
    "meta.dofe_name": "Uluslararası Gençlik Ödülü-Türkiye ",
    "route.profile": "Profil",
    "roles.super_user": "Süper-kullanıcı",
    "dashboard.while_you_were_gone": "Siz buralarda yokken",
    "label.no_note_from_award_leader": "Ödül Ofisi tarafından iade edildi (revizyon notu olmadan)",
    "label.middle_name": "İkinci ad",
    "moduleTitle.new_activity": "Yeni Faaliyet",
    "organisation.would_you_like_to_remove": "Bu kurumu kaldırmak istiyor musunuz?",
    "label.state_province": "Ülke/İl/Bölge",
    "moduleTitle.your_home_address": "Ev adresiniz",
    "tabs.sign_offs": "Ödül Bitirme Onayları",
    "moduleTitle.logs": "Faaliyet Kayıtları",
    "button.view_more": "Daha fazla",
    "label.profile": "Profil",
    "label.title": "Ünvan",
    "tabs.award_signoff": "Ödül Bitirme Onayı",
    "label.post_code": "Posta Kodu",
    "states.ceremony_certificate": "Ödül Töreni & Sertifika",
    "label.code": "Operatör Referansı",
    "parentalConsent.i_consent_to_the_provision_of_any": "13. Kişisel bilgilerin (katılımcı bilgileri dahil) Ödül Merkezi ve Ödül Otoritesi tarafından kullanılmasına izin veriyorum. Bu bilgilerin ilgili Ödül Otoritesi ile ilgili gizlilik ilkesine (gizlilik politikası belirli dönemlerde güncellenebilir), gizlilik düzenlemesine, standartlarına, yönergelerine ya da talimatlarına uygun şekilde kullanılmasına izin veriyorum.",
    "label.user_guide_web_participant": "Web Kullanıcı Kılavuzu - Katılımcı",
    "label.award_unit_type": "Ödül Merkezi Türü",
    "states.complete": "",
    "table.participant_state": "Katılımcı durumu",
    "pageTitle.my_organization_payment": "Kurumum - Ödeme ",
    "table.approved": "Onaylandı",
    "pageTitle.my_organization_contacts": "Bağlı Olduğum Kurum-Kişiler",
    "warning.award_marked_as_paid_registration": "Uyarı: Bu Ödül kaydı ödenmiş olarak işaretlendi. Onaylamadan önce lütfen ödeme ve geri ödeme yönergelerine bakın.",
    "states.change_to_state": "Değiştirerek <strong>{state}</strong> durumuna getir?",
    "label.integer": "Tamsayı",
    "notifications.translationUpdateInterrupted": "Bildirim çevirileri güncelleme engellendi",
    "notifications.password_has_been_changed": "Şifre Değiştirildi",
    "button.invite_assessor": "Danışman davet et",
    "label.other_activity": "Diğer Faaliyet",
    "notifications.parental_consent_has_been_sent": "Ebeveyn onayı gönderildi",
    "button.revise": "Düzelt",
    "errors.end_date_must_be_after_start_date": "Bitiş tarihi başlangıç tarihinden sonra olmalı",
    "label.award_leader_signoff_date": "Ödül Lideri bitirme onayı tarihi",
    "parentalConsent.i_understand_every_participant_must": "8. Tüm katılımcıların, Ödül Programı'na bir Ödül Merkezi'ne  bağlı olarak katılması gerektiğini ve Ödül Merkezleri'nin katılımcıların kayıt isteklerini, faaliyetlerini onaylama ya da reddetme hakkını saklı tuttuklarını anlıyorum.",
    "moduleTitle.policies": "Politikalar",
    "pageTitle.tasks_aj": "Macera ve Keşif Yolculuğu",
    "global.day": "gün ",
    "moduleTitle.coordinator": "Koordinatör",
    "label.region": "Bölge",
    "button.add_history_record": "Ödül Deneyimi kaydı ekle",
    "moduleTitle.adventurous_journey_template_settings": "Macera ve Keşif Yolculuğu Şablon Ayarları ",
    "notifications.personal_details_have_been_updated": "Kişisel bilgiler güncellendi",
    "sidebar.ics": "Bağımsız Ülkeler (GBT)",
    "table.independent_award_centre": "Bağımsız Ödül Merkezi",
    "label.undelivered_mail_reason": "E-postanın teslim edilmemesinin nedeni",
    "table.utc_date_time": "",
    "moduleTitle.emails": "Email adresleri",
    "label.backoffice": "Arka ofis",
    "moduleTitle.parent_consent": "Ebeveyn/Veli Onayı",
    "label.photo_consent_given": "Katılımcı, profil resminin tanıtım için kullanılmasına izin vermektedir.",
    "moduleTitle.authorising_contact": "Yetkili Kişi Bilgileri",
    "label.assessment_with_role": "{role} değerlendirme",
    "dashboard.type_of_awards": "Ödül Merkezi Türü",
    "moduleTitle.payment": "Ödeme",
    "states.in_progress": "İlerliyor",
    "logs.no_logs": "Faaliyet Kaydı Yok",
    "sidebar.my_office": "Benim Ofisim",
    "label.assessor_report": "Assessor/ Denetmen Raporu",
    "notifications.rp_has_been_signed_off": "Toplumsal Uyum Projesi tamamlandı",
    "tabs.labels": "Etiketler",
    "sidebar.payments": "Ödemeler",
    "meta.profile_questions": "Profil soruları",
    "label.fax": "Faks",
    "label.email_help_custom_link": "Özel bağlantı, belirtilmişse",
    "label.last_name": "Soyad",
    "organisation.manage_gop": "Global Operasyon Ortağını Yönetin",
    "table.parental_consent": "Ebeveyn Onayı",
    "dashboard.participant_by_level": "Katılımcılar- Kategorilerine göre",
    "tabs.award_leaders": "Ödül Liderleri",
    "label.i_confirm_that_ive_witnessed": "Katılımcının faaliyet kayıt formu için aşağıdaki faaliyetleri yaptıklarına tanıklık ettiğimi onaylıyorum.",
    "table.lead_coordinator": "Ana Ödül Koordinatörü",
    "states.deleted": "Silindi",
    "label.no_answers": "Hiçbir cevap yok",
    "button.add": "Ekle",
    "label.exchequer_number": "Kaynak A/c No.",
    "label.waiting": "Bekleniyor",
    "label.email_help_person_full_name": "Kişi tam adı.",
    "tasks.return_registration": "Kaydı Onaylamadan Geri Gönder",
    "notifications.state_aj_preparation_training_has_been_changed": "Macera ve Keşif Yolculuğu Hazırlık & Eğitim durumu değiştirildi. ",
    "label.parent_approval": "Ebeveyn Onayı",
    "table.assessor_approve": "Assessor/Denetmen Onayı",
    "errors.some_fields_requires_your_attention": "Bazı bölümleri incelemelisiniz",
    "aj.qualifying_journey": "Asıl Yolculuk",
    "route.awards": "Ödüller",
    "table.registration": "Kayıt",
    "pageTitle.assessors": "Danışmanlar",
    "notifications.award_has_been_updated": "Ödül güncellendi",
    "errors.must_be_one_of": "Bunlardan biri olmalı: {enums}",
    "pageTitle.logs": "Kayıtlar ",
    "notifications.notifications.invitation_has_been_sent": "Davet gönderildi",
    "route.national_offices": "Ulusal Ofisler",
    "notifications.training_has_been_updated": "Eğitim güncellendi",
    "label.parent_last_name": "Ebeveynin Soyadı",
    "table.leaders": "Ödül Liderleri",
    "states.award_level_complete": "Ödül Kategorisi Tamamlandı",
    "button.reset": "Sıfırla",
    "sidebar.my_award_unit": "Ödül Merkezim",
    "pageTitle.all_aj_events": "Tüm Macera ve Keşif Yolculuğu Etkinlikleri",
    "label.activity": "Faaliyet",
    "moduleTitle.are_you_sure": "Emin misiniz?",
    "route.gold_level": "Altın Kategorisi",
    "table.evidence": "Kanıt",
    "label.delivery_confirmed": "Ebeveyn Onayı alındı",
    "parentalConsent.as_the_parent": "Ebeveyn olarak, resimlerin Uluslararası Ödül Vakfı tarafından tanıtım amaçlı kullanılmasına izin veriyorum.",
    "label.awardMode.offline": "Çevrimdışı",
    "tasks.approve_registration": "Kaydı Onayla",
    "note.change_the_email_will_change": "Not: Email adresinizi değiştirirseniz, sisteme taşınacak email adresiniz de değişecektir. ",
    "notifications.participant_has_been_approved": "Katılımcı onaylandı",
    "label.reached_activity_limit": "Bu bölüm için faaliyet limitine ulaşıldı. Katılımcılar her bölüm için en fazla 3 faaliyet yapabilir. ",
    "label.facebook": "Facebook",
    "notifications.label_has_been_removed": "Etiket güncellendi.",
    "label.action_required": "",
    "notifications.preparation_training_has_been_removed": "Hazırlık ve Eğitim kaldırıldı",
    "pageTitle.settings": "Ayarlar",
    "participant.level_registration_date": "{value} kayıt tarihi",
    "notifications.question_has_been_removed": "Soru kaldırıldı",
    "label.email_help_award_leader_full_name": "Ödül Liderinin tam adı",
    "sidebar.leaders": "Ödül Liderleri",
    "notifications.participants_have_been_transferred": "Katılımcılar taşındı",
    "tabs.assessors": "Danışmanlar",
    "sidebar.dashboard": "Pano",
    "pageTitle.independent_award_centers": "Bağımsız Ödül Merkezleri",
    "label.search": "Ara",
    "moduleTitle.office_labels": "Ofis Etiketleri",
    "label.note_from_participant": "Katılımcıdan Not",
    "errors.required_field": "Gerekli Alan",
    "tasks.approve_task": "Görevi Onayla",
    "logs.edit_log": "Faaliyet kaydını düzenle",
    "table.state": "İl",
    "moduleTitle.level_summary": "Kategori Özet",
    "moduleTitle.guides": "Kılavuzlar",
    "modal.close": "Kapat",
    "label.parent_first_name": "Ebeveynin Adı",
    "parentalConsent.i_understand_that_the_participant": "1. Bu form doldurulmadan (ebeveyn onay formu dahil) katılımcının Ödül Programı'na başlayamayacağını; bu formun, gerekli ödeme ile birlikte Ödül Otoritesine verildikten sonra onay işleminin başlayacağını anlıyorum.",
    "tabs.award_units": "Ödül Merkezleri",
    "table.hours": "Saat",
    "label.type": "Tür",
    "notifications.adventurous_journey_has_been_removed": "Macera ve Keşif Yolculuğu Kaldırıldı",
    "label.aj_is_not_approved_yet": "Macera ve Keşif henüz onaylanmamıştır.",
    "roles.authorizing_contact": "Yetkili Kişi",
    "table.date_submitted_to_office_signoff": "Ulusal Ofis Ödül Bitirme Onayına Gönderildiği Tarih ",
    "notifications.section_has_been_returned": "Bölüm onaylanmadan geri gönderildi",
    "table.created_by": "Oluşturan:",
    "route.user_guide_web_participant": "Web Kullanıcı Kılavuzu - Katılımcı",
    "route.templates": "Şablonlar",
    "states.awaiting_sign_off": "Bitirme Onayı (Ödül Lideri)",
    "table.phone": "Telefon",
    "label.parental_consent": "Ebeveyn Onayı",
    "label.org_contact_will_be_deleted": "Bu kişinin bu kuruluşta sahip olduğu son rolü kaldırıyorsunuz. Kişisel bilgileri ilgili kişi olarak tutmak mı yoksa kişiyi bu kuruluştan tamamen kaldırmak mı istiyorsunuz?",
    "route.bronze_level": "Bronz Kategorisi",
    "label.invoice_currency": "Fatura Para Birimi",
    "button.new_label": "Yeni etiket",
    "error.server_cannot_be_reached_at_the_moment": "Şu anda sunucuya bağlanılamıyor. Lütfen daha sonra yeniden deneyiniz. Eğer sorun devam ederse, lütfen destek ekibimizle iletişime geçiniz.",
    "notifications.contact_has_been_created": "Yeni kişi oluşturuldu",
    "pageTitle.profile_questions": "Profil Soruları",
    "table.observation_files": "Gözlem dosyaları",
    "table.participants": "Katılımcılar",
    "tasks.no_evidence": "Kanıt yok",
    "button.edit": "Düzenle",
    "moduleTitle.leader": "Ödül Lideri",
    "notifications.new_template_has_been_updated": "Yeni şablon güncellendi",
    "table.name": "Ad",
    "label.no_results": "Sonuç Yok ",
    "moduleTitle.documents": "Belgeler",
    "button.invite": "Davet et",
    "label.goal": "Hedef",
    "pageTitle.nao_award_units": "Ulusal Ofis- Ödül Merkezleri",
    "label.award_delete_participant_id": "Katılımcı kimliği",
    "errors.at_least_num_characters": "En az {length} uzunluğunda olmalı",
    "label.email_help_note": "Özel not, belirtilmişse",
    "label.person_status.activating": "",
    "moduleTitle.remove_role": "Bu görevi silinsin mi?",
    "label.total": "Toplam",
    "label.delete_participant_award_info": "BU EYLEM GERİ DÖNÜŞSÜZDÜR. GİRDİĞİNİZ DETAYLARIN DOĞRU OLDUĞUNU LÜTFEN İKİ KEZ KONTROL EDİN.\nBir Ödül Seviyesini silmek üzeresiniz. Lütfen şunlara dikkat edin:\na) Katılımcının birden fazla Ödül Seviyesine sahip olması gerekir.\nb) Ana faaliyet, silmek üzere olduğunuz Ödül Seviyesinin bir parçasıysa sıfırlanacaktır.\nc) Silme işleminden sonra iki Ödül kalırsa, Ödül Yetkilendirme/Tamamlandı/Tören durumlarından herhangi birinde değilse, ana etkinlik daha düşük Ödül Seviyesine ayarlanacaktır.",
    "route.leaders": "Ödül Liderleri",
    "table.start_date": "Başlangıç Tarihi",
    "moduleTitle.coordinators": "Ödül Koordinatörleri",
    "button.create": "Oluştur",
    "tabs.awards": "Ödüller",
    "parentalConsent.form_has_been_sent": "Ebeveyn onayı gönderildi.",
    "states.journey_approval": "Macera ve Keşif Yolculuğu Onayı",
    "pageTitle.reports": "Raporlar",
    "table.journey_type": "Yolculuk Türü",
    "label.yes": "Evet",
    "pageTitle.assessor_report": "Danışman Raporu",
    "label.organization": "Kurum",
    "notifications.award_leader_has_been_updated": "Ödül Lideri güncellendi",
    "moduleTitle.edit_role": "Görevi düzenle",
    "table.journey_activity": "Yolculuk Tipi",
    "label.location": "Konum",
    "label.update_translations_error_item": "{language}, kod: {localeCode}, proje: {projectCode} için çeviri güncellemesi başarısız oldu çünkü",
    "pageTitle.adventurous_journeys": "Macera ve Keşif Yolculukları",
    "global.assessor": "Assessor/ Denetmen",
    "moduleTitle.profile_questions": "Profil Soruları",
    "activity.cannot_edit_activity_if_award_in_state": "Ödül {state}'da ise, düzenlenemez",
    "moduleTitle.assessor_detail": "Danışman Bilgileri",
    "parentalConsent.i_understand_that_upon_acceptance_into": "10. Katılımcının, Ödül Merkezi tarafından Ödül Programına katılımı onaylandıktan sonra bir Kayıt Defteri alacağını ya da Online Record Book (ORB) sistemine kaydının sağlanacağını anlıyorum. Katılımcı Kayıt Defterinin/ ORB sisteminin içinde yer alan ya da faaliyetlere başlamadan önce katılımcıya verilecek olan Ödül Şartları belgesini okumakla yükümlü olduğunu biliyorum. Ödül Merkezi'nin, Ödül Programı şartlarının karşılanıp karşılanmadığının takdir yetkisine sahip olduğunu dolayısı ile Ödül Programı'nın Bronz, Gümüş ya da Altın kategorisinde olması gerekeceğinin takdir yetkisine sahip olduğunu anlıyorum.",
    "notifications.award_has_been_returned": "Ödül onaylanmadan geri gönderildi",
    "label.code_of_conduct": "Davranış kodu",
    "button.new_contact": "Yeni Kişi",
    "tabs.payments": "Ödemeler",
    "roles.naa_oa_staff": "Ulusal Ödül Otoritesi Personeli",
    "label.switch_organisation_hint": "Bilgi kutucuğunu sağ üst küşede bulunan 'Kurum Değiştir' butonuna tıklayarak açabilirsiniz",
    "label.expiration_date": "Bitiş tarihi",
    "tabs.participants": "Katılımcılar",
    "table.practice": "Deneme Yolculuğu",
    "notifications.one_activity_has_to_remain": "Bu bölümde bir faaliyet silinmeden bırakılmalıdır.",
    "label.qualifications": "Yetkinlikler/Beceriler",
    "states.organization_approval": "Kurum Onayı",
    "errors.must_be_an_integer": "Tam sayı olmalı",
    "participant.send_confirmation_email_again_question": "Tekrar onay emailini gönder?",
    "button.dismiss": "Yoksay",
    "table.advice": "Tavsiye",
    "label.years_of_working_experience": "Deneyim yılı",
    "notifications.search_failed": "Arama sırasında hata oluştu. Lütfen daha sonra yeniden deneyiniz.",
    "notifications.changes_have_been_saved": "Değişiklikler kaydedildi",
    "moduleTitle.resend_parental_consent_link": "Ebeveyn onay linkini bir daha gönder?",
    "label.activity_type": "Faaliyet Türü",
    "label.change_award": "Ödül Kategorisini Değiştir",
    "label.email": "Email adresi",
    "button.remove": "Kaldır",
    "button.download": "İndir",
    "label.vat_treatment": "KDV İşlemi",
    "pageTitle.aj_template_new": "Yeni Macera ve Keşif Yolculuğu Şablonu",
    "table.per_page": "sayfa başına",
    "notifications.translations_has_been_updated": "Bildirim çevirileri güncellendi",
    "notification.award_mode_has_been_updated": "Ödül durumu güncellenmiştir",
    "tasks.revise_item": "Öğeyi Gözden Geçir",
    "button.resend_parental_consent": "Ebevyn onayını yeniden gönder",
    "table.weeks_completed_required": "Gerekli/Bitirilen Haftalar",
    "label.last_modified": "Son düzenleme",
    "table.major": "Uzun Süreli Faaliyet",
    "label.vat_number": "KDV No.",
    "errors.passwords_dont_match": "Şifre eşleşmiyor",
    "table.country": "Ülke",
    "sidebar.guides_and_policies": "Kılavuzlar ve Politikalar",
    "notifications.question_has_been_updated": "Soru güncellendi",
    "table.participant_name": "Katılımcı Adı",
    "label.registration_approval_date": "Kayıt onay tarihi",
    "notifications.auth_code_is_no_longer_valid": "Yetkilendirme kodu artık geçersiz",
    "errors.must_be_no_more_than": "En fazla karakter sayısı: ",
    "notifications.event_has_been_rejected": "Etkinlik onaylanmadan geri gönderildi",
    "tabs.customizations": "Kişiselleştirmeler",
    "label.name_organization": "İsim",
    "button.add_log": "Faaliyet Kaydı Ekle",
    "moduleTitle.invite_assessor": "Danışman davet et",
    "label.resend_confirmation_email": "Doğrulama e-postasını yeniden gönder",
    "text.all_participants_will_be_transfered": "Tüm katılımcılar yeni bir Ödül Liderine atanacaktır",
    "label.repeat_email": "Email adresi tekrar",
    "errors.email_or_phone_required": "E-posta veya telefon gereklidir",
    "notifications.role_has_been_updated": "Rol güncellendi",
    "roles.if_staff_stat_user": "Uluslararası Ödül Vakfı İstatiksel Kullanıcı",
    "participant.delete_account": "Hesabı Sil",
    "moduleTitle.would_you_like_to_remove_this_log": "Bu faaliyet kaydını silmek istiyor musunuz?",
    "sidebar.sgops": "",
    "label.prepare_new_email": "Yeni e-posta hazırla",
    "table.journey_category": "Yolculuk Kategorisi",
    "sidebar.manual_data_import": "Manuel veri girişi",
    "label.created_after_date": "Şu tarihten sonra oluşturuldu:",
    "route.my_organization": "Bağlı Olduğum Kurum",
    "button.show_list": "Listeyi göster",
    "label.leaders": "Ödül Liderleri ",
    "notifications.log_has_been_modified": "Faaliyet kaydı değiştirildi",
    "button.upload_file": "Dosya Yükle",
    "moduleTitle.which_section_do_you_want_to": "''Devam ediliyor'' statüsüne döndürmek istediğiniz bölüm hangisi?",
    "tabs.bronze_level": "Bronz Kategorisi",
    "notifications.participants_have_been_saved": "Katılımcılar kaydedildi",
    "pageTitle.aj_template_detail": "Macera ve Keşif Yolculuğu",
    "label.parent_email": "Ebeveyn&#39; 'nin /Veli'nin &#39;s Email Adresi",
    "map.appr_location": "Tahmini adres:",
    "notifications.log_has_been_removed": "Faaliyet Kaydı Silindi",
    "notifications.label_has_been_assigned": "",
    "pageTitle.tasks_undelivered_emails": "Teslim edilmemiş e-postalar",
    "button.stay": "Sayfada Kal",
    "table.previous_level": "Önceki Kategori",
    "label.award_start_date": "Ödül Programı'na Başlama Tarihi",
    "assessor_report.returned_to_participant": "Katılımcıya geri gönderildi",
    "pageTitle.tasks_assessors_registration": "Danışman Kaydı",
    "aj.cannot_modify_award": "Katılımcı Macera ve Keşif Yolculuğu'na atanmış ise, Ödül Kategorisinde bir değişiklik yapamazsınız. ",
    "moduleTitle.lost_internet_connection": "İnternet bağlantınız kopmuş gibi gözüküyor",
    "states.ceremony": "Ödül Töreni",
    "participant.reactivate_account": "Hesabı Etkinleştir",
    "label.birthdate": "Doğum Tarihi",
    "pageTitle.assessment_send_successfully": "Değerlendirme başarıyla gönderildi",
    "states.assessor_approval": "Danışman Onayı",
    "award.change_award_level": "Ödül Kategorisi değiştir",
    "label.url_no_longer_valid": "URL artık geçerli değil.",
    "button.update": "Güncelle",
    "label.secondary_email": "İkincil email adresi",
    "button.role_edit": "Düzenle",
    "table.award_leader": "Ödül Lideri",
    "label.level": "Kategori",
    "tasks.evidence": "Kanıt",
    "notifications.participant_is_already_in_list": "Katılımcı listede bulunuyor",
    "button.clear": "Temizle",
    "label.allow_log_after_25_yoa": "",
    "states.setup": "Oluştur",
    "table.activity": "Faaliyet",
    "label.copy_to_clipboard": "{text} panoya kopyalandı.",
    "route.award_units": "Ödül Merkezleri",
    "button.upload_photo": "Resim yükleyin",
    "table.hours_completed_required": "Tamamlanmış/Gerekli Saat",
    "table.first_name": "Ad",
    "notifications.adventurous_journey_has_been_returned": "Macera ve Keşif Yolculuğu onaylanmadan geri gönderildi",
    "pageTitle.national_offices": "Ulusal Ofisler",
    "notifications.you_have_been_logged_in": "Giriş yaptınız",
    "logs.offline": "Çevrimdışı",
    "moduleTitle.add_role": "Görev Ekle",
    "label.user_app_guide_participant": "Uygulama Kulanım Kılavuzu - Katılımcı",
    "notifications.file_has_been_removed": "Dosya Kaldırıldı",
    "label.send_message": "Mesaj gönderin",
    "button.select": "Seç",
    "label.reason_of_deletion": "Silme nedeni",
    "label.user_guide": "Kullanıcı Kılavuzu",
    "pageTitle.nao_participants": "Ulusal Ofis-Katılımcılar",
    "tabs.sub_operating_partners": "",
    "table.uploaded_by": "Yükleyen Kişi:",
    "tasks.approve_item": "Öğeyi Onayla",
    "tasks.restore_participant_registration": "Katılımcı kaydını yenile?",
    "label.awardMode.hybrid": "Karma",
    "table.first_activity_started": "İlk faaliyet başladı",
    "moduleTitle.dates": "Tarihler",
    "table.no_results": "Sonuç Yok",
    "states.registration_approval": "Kayıt Onayı",
    "table.breakdown_of_hours": "Saat dağılımı",
    "pageTitle.tasks_registration": "Katılımcı Kaydı",
    "button.create_new": "Yeni Oluştur",
    "sidebar.todolist": "Yapılacaklar Listesi",
    "label.active_participants": "Aktif Katılımcılar",
    "moduleTitle.postalAddress": "",
    "tasks.return_task": "Görevi Onaylamadan Geri Gönder",
    "organisation.change_organisation_state": "Kurumun Durumunu Değştir",
    "moduleTitle.roles": "Görevler",
    "label.no_config_key_available": "Bu bölüm için kurulum anahtarı bulunmamaktadır",
    "placeholder.selectLanguage": "Dil seç",
    "states.office_signoff": "Bitirme Onayı (Ulusal Ofis)",
    "notifications.translations_has_been_updated.failure": "Bildirim çevirileri güncelleme hatası",
    "logs.minute": "dakika",
    "label.last_activity": "Son Faaliyet",
    "sidebar.user_guide": "Kullanıcı Kılavuzu",
    "label.trained_award_leader": "Eğitim almış Ödül Lideri ",
    "table.progress": "İlerleme",
    "table.suboperating_authorities": "Alt-Operasyon Otorite Birimleri",
    "activity.cannot_edit_activity_offline": "Katılımcı Çevrimdışı modda. Bu durumda faaliyet, Macera ve Keşif Yolculuğu ve Toplumsal Uyum projesini düzenleyemezsiniz.",
    "label.user_does_not_have_permissions": "Kullanıcı <strong>{user}</strong> bu içeriği göremez. ",
    "notifications.assessor_has_been_approved": "Danışman onaylanmadı",
    "route.activity_approval": "Faaliyet Onayı",
    "moduleTitle.role": "Görev",
    "button.run": "Çalıştır",
    "label.to": "Kime",
    "notifications.file_has_been_updated": "Dosya Güncellendi",
    "moduleTitle.edit_coordinator": "Koordinatörü Düzenle",
    "notifications.authorization_code_is_no_longer_valid": "Yetkilendirme kodu artık geçersiz",
    "button.reject": "Düzelt",
    "label.label.participant_status": "Katılımcı Durumu",
    "award.gold_level": "Altın Kategorisi",
    "sidebar.variables": "Değişkenler",
    "parentalConsent.checkbox_copy": "{firstName} {lastName}'nın ebeveyni olduğumu onaylıyorum ve Ödül Programı'na {organizationName} , bir Ödül Lideri gözetiminde katılmasına izin veriyorum. Burada ve Ödül Operatörü'nün internet sitesinde bulunan, Katılım Koşullarını okudum, anladım ve onaylıyorum.",
    "button.go_to_dashboard": "Panoya Git",
    "button.add_option": "Seçenek ekle ",
    "label.is_completed": "Tamamlandı",
    "pageTitle.award_units": "Ödül Merkezleri",
    "states.completed": "Tamamlandı",
    "button.adventurous_journey_template_settings": "Macera ve Keşif Yolculuğu Şablon Ayarları ",
    "label.system_rights": "Sistem Hakları",
    "label.assessor_assesstment_award_start_date": "Ödül Değerlendirme Başlangıç Tarihi",
    "label.update_translation_question": "",
    "button.login": "Giriş ",
    "label.name_of_the_unit": "Ödül Merkezi Adı",
    "button.send": "Gönder",
    "award.ajs": "Macare ve Keşif Yolculukları",
    "meta.payments_expired": "Ödemeler - Süresi Doldu",
    "label.age": "Yaş",
    "notifications.payment_info_updated": "Ödeme bilgileri güncellendi",
    "table.is_completed": "Tamamlandı",
    "table.invited_by": "Davet eden kişi:",
    "route.files": "Dosyalar",
    "route.assessors": "Danışmanlar",
    "info.aj_supervisor_is_mandatory": "Deneme Yolculuğu için değerlendirme talebini Supervisor, Asıl Yolculuk için değerlendirme talebini Assessor alacaktır.",
    "pageTitle.my_participants": "Katılımcılarım",
    "label.change_leader_status": "Ödül Lideri durumu değiştirildi",
    "moduleTitle.parent_consent_form": "Ebeveyn/Veli Onay Formu",
    "notifications.authorization_contact_has_been_set": "Yetkili kişi oluşturuldu",
    "button.close": "Kapat",
    "label.independent_country": "Bağımsız Ülke",
    "notifications.aj_preparation_training_has_been_returned": "Macera ve Keşif Yolculuğu Hazırlık&Eğitim onaylanmadan geri gönderildi. ",
    "route.history_log": "Faaliyet Kayıt Geçmişi",
    "participant.account_settings": "Hesap Ayarları",
    "label.bulk_action_error_item": "{globalId} {firstName} {lastName} {email} çünkü",
    "label.orb_account": "ORB Hesabı",
    "notifications.file_url_is_not_specified_in_configuration": "Tanımlanmamış dosya uzantısı konfigürasyonu",
    "notifications.award_unit_has_been_removed": "Ödül Merkezi/Bağımsız Ödül Merkezi kaldırıldı",
    "table.parent": "Ebeveyn",
    "label.mode_of_transport": "Yolculuk Tipi",
    "label.parental_consent_email_info": "Ebeveyn email adresini kontrol etmeyi ve onayı Ödül Detayları sayfasından manuel olarak yollamayı unutmayınız.",
    "label.current_award": "Güncel Ödül ",
    "table.action": "İşlem",
    "pageTitle.suboperating_authorities": "Operatör Otorite/Ortak",
    "notifications.award_leader_has_been_assigned": "Ödül Lideri atandı",
    "tabs.sign_offs_locally": "Ulusal Ofis Bitirme Onayları ",
    "Activity log has been restored": "notification.log_has_been_restored",
    "sidebar.naos": "Ulusal Ödül Otoriteleri",
    "tabs.aj_templates": "Macera ve  Keşif Yolculuğu Şablonları",
    "notifications.logging_out": "Çıkış yapılıyor...",
    "label.update_label": "Update label",
    "button.organisation_settings": "Kurum Ayarları",
    "tabs.independent_award_centers": "Bağımsız Ödül Merkezleri",
    "label.current": "Şimdiki\n",
    "table.location": "Konum",
    "button.search": "Ara",
    "notifications.aj_preparation_training_has_been_approved": "Macera ve Keşif Yolculuğu, hazırlık ve eğitim onaylandı",
    "route.participants": "Katılımcılar",
    "label.other_location_information": "Diğer Konum Bilgileri",
    "label.number_of_records": "Kayıt sayısı",
    "translationsManagement.infoLabel": "Çeviriler Yönetim bilgi ",
    "parentalConsent.i_consent_to_pay_all": "5. Ödül Programı dahilinde bir faaliyette ya da yolculukta gerçekleşebilecek olan kaza, yaralanma, hastalık ya da ölüm durumlarında katılımcının doktor, hastane, hemşire bedellerinin katılımcı adına ödemem gerekeceğini kabul ediyorum.",
    "label.nationality": "Milliyet",
    "states.approval": "Onay",
    "notifications.something_went_wrong": "Bir yanlışlık oldu",
    "aj.practice": "Deneme Yolculuğu",
    "label.addressLine2": "Adres (ikinci satır)",
    "label.please_leave_a_note": "Lütfen bir not bırakınız",
    "placeholder.select": "Seç",
    "label.observations": "Gözlemler",
    "label.aim": "Hedef",
    "label.addressLine1": "Adres (ilk satır)",
    "roles.aj_instructor": "Macera ve Keşif Yolculuğu Eğitmeni",
    "meta.payments_waiting": "Ödemeler - Beklemede",
    "label.award_to_delete": "Silinecek Ödül Seviyesi",
    "label.category": "Kategori",
    "roles.instructor": "Eğitmen",
    "moduleTitle.remove_customization_and_reset": "Kişiselleştirmeyi kaldır ve kurulum değerini sıfırla?",
    "notifications.participant_registration_has_been_restored": "Katılımcı kaydı yenilendi",
    "organisation.change_award_unit_mode": "Kurum işlevi/biçimini değiştir",
    "table.organization_type": "Organizasyon tipi",
    "notifications.participant_has_been_deleted": "Katılımcı silindi",
    "label.language_settings": "Dil Ayarları",
    "notifications.event_has_been_approved": "Etkinlik onaylandı",
    "label.password": "Şifre",
    "label.text": "Metin",
    "table.observations": "Gözlemler",
    "notifications.participant_has_been_created": "Katılımcı oluşuturuldu",
    "table.note_for_al": "Ödül Liderine Not",
    "label.payment_confirmed": "Ödeme Onaylandı",
    "label.previous_completed_award_level": "Önceki Kategori (ORB'de değil)",
    "pageTitle.new_aj_event": "Yeni Macera ve Keşif Yolculuğu Etkinliği",
    "label.backend": "Arka uç",
    "label.relationship_to_participant": "Katılımcı ile ilişkisi",
    "award.physical_recreation": "Fiziksel Gelişim",
    "contact.collect_emails": "E-posta göndermek için e-posta adreslerini toplayın",
    "moduleTitle.assessor_report_reject": "Danışman Raporu Reddi",
    "label.supervisor_report": "Supervisor/ Gözetmen Raporu",
    "table.role": "Görev",
    "route.user_guide_web_nao": "Web Kullanıcı Kılavuzu - Ulusal Ödül Operatörü",
    "label.page_not_found": "404 - Sayfa Bulunamadı",
    "table.labels": "Etiketler",
    "notifications.file_has_been_uploaded": "Dosya Yüklendi",
    "moduleTitle.address": "Adres",
    "moduleTitle.lead_coordinator": "Ödül Merkezi Koordinatörü",
    "pageTitle.login": "Giriş Yap",
    "label.frontoffice": "Ön ofis",
    "participant.would_you_like_to_remove_registration": "Bu kaydı silmek ister misiniz?",
    "notifications.rp_has_been_setup": "Toplumsal Uyum Projesi planlandı",
    "moduleTitle.award_unit": "Ödül Merkezi",
    "button.remove_file": "Dosyayı kaldır",
    "moduleTitle.billing_address": "Fatura Adresi",
    "pageTitle.my_aj_events": "Macera ve Keşif Yolculuğu Etkinliklerim",
    "route.tasks": "Görevler",
    "button.confirm": "Onayla",
    "label.national_award_authority": "Ulusal Ödül Otoritesi",
    "label.independent_award_centre": "Bağımsız Ödül Merkezi",
    "award.generate_award_report": "Rapor oluştur",
    "route.my_region_office_customization": "Ulusal Ofis - Kişiselleştirmeler",
    "label.email_help_aj_category": "Macera ve Keşif Yolculuğu Kategorisi",
    "label.your_report_has_been_rejected": "Değerlendirmeyi onay almadan geri gönderdiniz",
    "notifications.password_change_request_has_been_sent": "Şifre değiştirme talebiniz gönderilmiştir",
    "tabs.detail": "Detaylar",
    "participant.change_participant_status": "Katılımcının durumunu değiştiriniz",
    "table.key": "anahtar\n",
    "label.find_address": "Adresi Bul",
    "notifications.assessor_has_been_rejected": "Danışman yeniden düzenlendi",
    "label.transfer_participants": "Katılımcılarıları taşıyın",
    "button.continue_to_payment_gateway": "Ödeme sayfasına devam et",
    "notifications.participant_registration_has_been_removed": "Katılımcı kaydı kaldırılmıştır.",
    "moduleTitle.page_not_found": "404- Sayfa Bulunamıyor",
    "route.adventurous_journeys": "Macera ve Keşif Yolculukları",
    "states.registration_assessment": "Kayıt Değerlendirmesi",
    "heading.change_award_unit_mode": "Ödül Merkezi durumunu değiştir",
    "label.user_guide_web_nao": "Web Kullanıcı Kılavuzu - Ulusal Ödül Operatörü",
    "tabs.silver_level": "Gümüş Kategorisi",
    "table.paid_by": "Ödeyen kişi",
    "label.your_report_has_been_successfully_sent": "Raporunuz başarıyla gönderildi.",
    "sidebar.my_organization": "Bağlı Olduğum Kurum",
    "pageTitle.participants": "Katılımcılar",
    "notifications.preparation_training_has_been_updated": "Hazırlık ve Eğitim güncellendi ",
    "moduleTitle.server_is_unreachable": "Sunucuya bağlanılamıyor",
    "label.last_activity_date": "Son etkinlik tarihi",
    "award.bronze_level": "Bronz Kategorisi ",
    "moduleTitle.award_units": "Ödül Merkezleri",
    "table.completed": "Tamamlandı",
    "moduleTitle.revise_message": "Mesajı gözden geçirme ",
    "table.lastUsed": "Son kullanılan\n",
    "award.bronze_to_gold_level": "Bronz'dan Altın kategorisine",
    "button.change_password": "Şifre Değiştir",
    "label.nao_price": "Ulusal Ödül Operatörü - bağış tutarı",
    "label.payment_state": "Ödeme Durumu",
    "label.wwc_expired": "''Çocuklar ile Çalışma Kontrolü'' numaranızın süresi doldu.",
    "label.award_office_signoff_date": "Ulusal Ofisi bitirme onayı tarihi",
    "label.award_unit": "Ödül Merkezi",
    "award.gold_level_short": "Altın",
    "moduleTitle.other_info": "Diğer Bilgiler",
    "table.note": "Not",
    "label.search_by_email_first_or_last": "Email adresi, ad ya da soyad ile ara",
    "tabs.history": "Ödül Deneyimi",
    "notifications.label_has_been_created": "Label has been created.",
    "tabs.unassigned_participants": "Atanmamış Katılımcılar",
    "table.main_award_leader": "Ödül Koordinatörü",
    "parentalConsent.i_as_the_parent": "3. Ben, ebeveyn olarak, Ödül Programı süresince var olabilecek yüksek riskli faaliyetlerin farkındayım ve Ödül Operatörünün uygulamalarının ya da sigortanın bu riski karşılamayacağının farkındayım. Katılımcının, Ödül Programı'na katılımından dolayı doğabilecek tüm risklerden tamamen katılımcı sorumludur.",
    "label.state": "Durum",
    "notifications.award_leader_has_been_removed": "Ödül Lideri kaldırıldı",
    "tabs.organization_detail": "Kurum Detayları",
    "table.operating_authorities": "Operasyon Otorite Birimleri",
    "label.available_labels": "",
    "modal.select": "Seç",
    "tabs.expired_payments": "Süresi Dolan Ödemeler",
    "moduleTitle.note_for_al": "Ödül Lideri için Not",
    "moduleTitle.confirm": "Onayla ",
    "notification.new_activity_added": "Yeni faaliyet eklendi",
    "notifications.award_leader_has_been_moved": "Ödül Lideri taşındı",
    "label.award_mode": "Ödül durumu",
    "label.phone": "Telefon",
    "notifications.organization_has_been_updated": "Kurum bilgisi güncellendi",
    "moduleTitle.assessor": "Assessor / Denetmen",
    "label.bulk_action_confirmation": "Toplu İşlem Onaylansın",
    "table.parent_approval": "Ebeveyn Onayı",
    "label.date_of_delivery": "Ebeveyn Onay Tarihi",
    "sidebar.assessors": "Danışmanlar",
    "label.journey_activity": "Yolculuk Tipi",
    "award.inactive_award": "Ödü'ü devre dışı bırak",
    "label.end_date": "Bitiş Tarihi",
    "label.orb_testing": "ORB Testi",
    "label.no_activities": "Faaliyet yok",
    "moduleTitle.please_confirm": "Lütfen onaylayınız",
    "button.login_with_another_account": "Başka Bir Hesapla Giriş Yap",
    "tasks.reject_registration": "Kaydı Reddet",
    "label.submitted_after_date": "Şu tarihten sonra gönderildi:",
    "label.update_translations_successful": "{count} öğe başarıyla değiştirildi.",
    "button.assign_leader": "Ödül Lideri ata",
    "table.already_running": "İlerliyor",
    "label.no": "Hayır",
    "label.count_items_selected": "{count} tane seçildi",
    "label.secondary_phone_number": "İkincil telefon numarası",
    "label.my_experience": "Deneyimlerim",
    "notifications.adventurous_journey_has_been_approved": "Macera ve Keşif Yolculuğu onaylandı",
    "pageTitle.mro_detail": "EMAS Ofis-Detaylar",
    "moduleTitle.nao_specific_info": "Ulusal Ödül Otoritesi Bilgileri",
    "label.preparing_document_for_import": "Belge aktarım için hazırlanıyor",
    "tasks.observations": "Gözlemler",
    "notifications.confirmation_email_has_been_sent": "Onay emaili gönderildi",
    "button.restore": "Yenile",
    "label.importing_file": "Belge aktarılıyor",
    "label.or_dont_agree": "ya da kabul etmiyor musunuz? Seçeneğiniz",
    "moduleTitle.award_leader": "Ödül Lideri",
    "label.me": "(ben)",
    "tabs.sub_global_operating_partners": "",
    "button.export_table": "Tabloyu dışa aktar",
    "organisation.move_award_unit": "Ödül Merkezini taşı",
    "label.file_category": "",
    "notifications.connecting_to_server": "Sunucuya bağlanılıyor...",
    "parentalConsent.i_understand_that_a_and_b": "11. Katılımcının uygun bir ehliyeti olmaması durumunda ve kullanılan motorlu araç ile yapılabilecek herhangi kaza sonucu oluşabilecek yaralanmaları kapsayan bir sigortası olmaması durumunda ve  <br /> b; katılımcını motorlu araç kullanmaması gerektiğini anlıyorum: <br /> a. b. a katılımcı, Ödül ile ilgili destek sağlayan ya da Ödül Programı'nı organize eden bir kişinin kullandığı araç ile seyahat edebilir; bu kişinin uygun ehliyeti bulunmalıdır. ",
    "table.reason": "Sebep",
    "pageTitle.contacts": "Kişiler",
    "states.award_leader_approval": "Ödül Lideri Onayı",
    "meta.payments": "Ödemeler",
    "label.suboperating_authority": "Operatör Otorite/Ortak",
    "route.my_region_office": "Ulusal Ofisim",
    "states.registration_not_approved": "Kayıt onaylanmadı",
    "label.direct_entrant": "Direk başlangıç yapan katılımcı",
    "tabs.all_participants": "Tüm Katılımcılar",
    "tabs.payment": "Ödeme",
    "label.email_help_activity_name": "Aktivitenin adı",
    "title.update_report": "Raporu güncelle",
    "label.repeat_new_password": "Yeni Şifre Tekrar",
    "label.other_roles": "ORB profil sayfası",
    "logs.hours": "saatler",
    "notifications.spreadsheet_has_been_imported_successfully": "Hesap tablosu başarılı bir şekilde aktarıldı",
    "label.bulk_action_question": "{count} tanesine toplu işlem yapma?",
    "moduleTitle.personal_details": "Kişisel Bilgiler",
    "label.bulk_action_emailing": "Seçilen katılımcıların e-posta adresleri",
    "route.my_events": "Etkinliklerim",
    "button.delete_award": "Ödül Seviyesini sil",
    "errors.include_both_lower_and_upper_case": "Büyük ve küçük harfler bulunmalı",
    "tabs.removed_participant_registrations": "Kaldırılmış Katılımcı Kayıtları",
    "sidebar.mynao": "Ulusal Ödül Otoritem",
    "tabs.office_details": "Ofis Detayları",
    "label.major": "Uzun Süreli Faaliyet",
    "tabs.documents": "Belgeler",
    "label.new_password": "Yeni Şifre",
    "sidebar.adventure_journey": "Macera ve Keşif Yolculuğu",
    "pageTitle.customizations": "Kişiselleştirmeler",
    "moduleTitle.assessor_report": "{role} raporu",
    "label.registration_date": "Kayıt Tarihi",
    "notifications.training_has_been_added": "Eğitim eklendi",
    "aj.qualifying": "Asıl Yolculuk",
    "moduleTitle.you_have_been_logged_out_session_terminated": "Oturum sona erdiği için çıkış yapıldı",
    "award.service": "Gönüllü Hizmet",
    "notifications.rp_state_has_been_changed": "Toplumsal Uyum Projesi'nin durumu değiştirildi",
    "label.ctest_access": "Site erişimini test edin",
    "table.created": "Oluşturuldu",
    "tasks.revise_task": "Görevi Gözden Geçir",
    "button.assign": "Atama yap",
    "button.return": "Geri Dön",
    "table.status": "Durum",
    "button.restore_activity": "Faaliyeti yenile",
    "tabs.new_aj_event": "Yeni Macera ve Keşif Yolculuğu Etkinliği",
    "roles.if_staff_viewer": "Uluslararası Ödül Vakfı Görüntüleyici Kullanıcı",
    "notifications.new_template_has_been_created": "Yeni şablon oluşturuldu",
    "global.something_went_wrong": "Bir hata oluştu",
    "table.expire_day": "Bitiş tarihi",
    "tabs.history_log": "Faaliyet Kayıt Geçmişi",
    "label.form_of_payment": "Ödeme Türü",
    "button.add_training": "Eğitim Ekle",
    "label.par_reg_cust_note": "Bu sekme, Katılımcı Kaydında görüntülenen alanları özelleştirmenize ve topladığınız veri miktarını etkilemenize olanak tanır. Değişikliklerin yapılmasını istiyorsanız, lütfen Bölge Ofisinize başvurun; bu değişiklikleri yalnızca IAF Sys Yöneticisi erişim hakkına sahiptir.",
    "label.my_qualification": "Yeterliliklerim",
    "button.add_new_profile_question": "Yeni profil sorusu ekle ",
    "table.operating_authority": "Operasyon Otorite Birimi",
    "table.aim": "Hedef",
    "table.awards": "Ödüller",
    "participant.deactivate_account": "Hesabı Devredışı Bırak",
    "table.organization_name": "Kuruluş",
    "label.email_help_award_leader_first_name": "Ödül Liderinin adı",
    "table.date": "Tarih",
    "tasks.would_you_like_to_delete": "Bu katılımcıyı silmek istiyor musunuz?",
    "notifications.configuration_value_has_been_updated": "Yetki kodu güncellendi",
    "ajTemplates.fill_from_template": "Şablondan doldur",
    "contact.send_test_email": "Deneme emaili gönder",
    "moduleTitle.aj_preparation_and_training": "Macera ve Keşif Yolculuğu Hazırlık ve Eğitim",
    "label.ce_be": "Özelleştirilebilir E-postalar (e-posta çevirileri)",
    "button.notify_participant": "Katılımcıya Dön",
    "label.parent_phone": "Ebeveyn&#39; Veli'nin &#39;s Telefon Numarası",
    "label.nao_regulations": "Ulusal Ödül Ofisi Düzenlemeleri",
    "award.skills": "Beceri Geliştirme",
    "label.reject_application": "başvuruyu reddet",
    "leader.delete_account": "Hesabı Sil ",
    "table.assign": "Atama yap",
    "roles.aj_supervisor": "Macera ve Keşif Yolculuğu Supervisorı / Gözetmeni",
    "label.logout": "Çıkış",
    "moduleTitle.award_leader_edit": "Ödül Lideri düzenle",
    "moduleTitle.training": "Eğitim",
    "notifications.coordinator_has_been_removed": "Ödül Koordinatör kaldırıldı",
    "tabs.operating_partners": "",
    "moduleTitle.main_award_leader": "Ödül Koordinatörü",
    "label.bulk_action_successful": "{count} tanesi değiştirildi.",
    "tasks.clear_email_revision": "E-posta revizyonunu temizle",
    "table.preparation": "Hazırlık",
    "table.delete": "Sil",
    "label.safeguarding_policy": "Uluslararası Ödül Vakfı'nın Koruma Politikası (Davranış Kuralları dahil)",
    "sidebar.reports": "Raporlar",
    "pageTitle.sub_global_operating_partners": "",
    "label.is_major_activity_confirmation": "Katılımcının zaten farklı ödül seviyesinde başlıca bir etkinliği var. Bir tane daha eklemek ister misiniz?",
    "pageTitle.operating_authorities": "Operasyon Otorite Birimleri",
    "label.delete_participant_award_modal_question_detail": "{participantId} katılımcısı için {awardLevel}'i silmek istediğinizden emin misiniz?",
    "label.confirmed": "Onaylandı",
    "notifications.invitation_has_been_sent": "Davet gönderildi",
    "pageTitle.independent_countries": "Bağımsız Ülkeler",
    "label.assessors_email": "Danışman email adresi",
    "tasks.approve_assessor_registration": "Danışman kaydını onayla",
    "table.award_duration": "Ödül Programı Süresi",
    "notifications.organization_has_been_moved": "Kurum taşındı",
    "pageTitle.nao_payment": "Ulusal Ofis-Ödeme",
    "participant.history_log": "Faaliyet Kayıt Geçmişi",
    "label.rejected_with_note": "Bir notla döndü: \"{note}\"",
    "label.already_running": "İlerliyor",
    "button.continue": "Devam et ",
    "award.no_data_to_show": "Gösterilecek veri yok\n",
    "participant.send_email_invitation_again_question": "Tekrar email daveti gönder?",
    "label.reason_for_changing_assessor": "Danışman değiştirme nedeni",
    "button.delete": "Sil",
    "moduleTitle.requirements_and_conditions": "Şartlar ve Koşullar",
    "roles.leader": "Ödül Lideri",
    "label.if_download_doesnt": "İndirme otomatik olarak başlamıyorsa internet tarayıcınızın pop up ayarlarını kontrol ediniz",
    "dashboard.your_todo_list": "Yapılacaklar Listeniz",
    "notifications.award_unit_has_been_returned": "Ödül Merkezi onaylanmadan geri gönderildi",
    "moduleTitle.participant_activities": "Katılımcı'nın Faaliyetleri",
    "errors.qualification_or_experience_required": "Nitelik veya deneyim gereklidir",
    "label.active_leaders": "Aktif Ödül Liderleri",
    "aj.preparation": "Hazırlık",
    "button.change_state": "Durum Değiştir",
    "label.current_password": "Mevcut Şifre",
    "pageTitle.global_operating_partners": "Global Operasyon Ortakları",
    "moduleTitle.contact_settings": "İletişim Ayarları",
    "button.remove_photo": "Resmi Kaldır",
    "notifications.activity_has_been_setup": "Faaliyet planlandı",
    "errors.must_be_more_than": "{limit} limittir, bundan daha fazla olamaz.",
    "table.goal": "Hedef",
    "notifications.coordinator_has_been_set": "Koordinatör oluşturuldu",
    "label.cc": "Cc",
    "label.duration": "Süre",
    "table.actions": "İşlemler\n",
    "participant.send_email_invitation_again": "Tekrar email daveti gönder?",
    "moduleTitle.would_you_like_to_remove_participant": "Bu katılımcıyı silmek istiyor musunuz?",
    "parentalConsent.i_authorise_employees": "4. Ödül Merkezi çalışanlarının ya da yetkililerinin, diğer katılımcıların, Ödül Programı'nın yapılmasında/organizasyonunda destek veren ve sürece dahil olan diğer kişilerin; katılımcının başına gelecek kaza, yaralanma, hastalık, ölüm gibi durumlarda (Ödül ile alakalı bir yolculuk, Ödül Programı ile alakalı faaliyetler esnasında), katılımcının gerekeli medikal tedavi ve desteği doktorlardan, hemşirelerden, diğer sağlık ekiplerinden alması veya hastanede konaklaması için gerekli aksiyonları almalarına izin veriyorum.",
    "button.reload_page": "Sayfayı yeniden yükle",
    "moduleTitle.update_translations": "Proje çevirilerini güncelleme",
    "label.report_description": "Aşağıdaki tablolarda, \"İçerilen alanlar\" ve \"Son güncellemeler\" sütunları şu anda yalnızca İngilizce olarak mevcuttur. Bunları başka dillere çevirmek için çözümler arıyoruz. Bu arada, lütfen özürlerimizi kabul edin - raporlama özelliğinin sizin için hâlâ yararlı olduğunu umuyoruz.",
    "table.email": "Email adresi",
    "label.new_goal": "Yeni Hedef",
    "label.participant_survey_parent": "",
    "errors.invalid_email_address": "Geçersiz Email Adresi",
    "pageTitle.new_contact": "Yeni Kişi",
    "sidebar.gops": "GOO",
    "button.manage_participants": "Katılımcıları Yönet",
    "errors.invalid_phone_format": "Geçersiz Telefon Numarası",
    "notifications.login_details_have_been_changed": "Giriş bilgileri değiştirildi",
    "moduleTitle.participant_logs": "Katılımcı'nın Faaliyet Kayıtları",
    "label.save": "Kaydet",
    "label.frequently_asked_questions": "Sıkça Sorulan Sorular",
    "label.city": "Şehir",
    "notifications.configuration_value_has_been_reset": "Kurulum değeri sıfırlandı",
    "states.office_sign_off": "Bitirme Onayı (Ulusal Ofis)",
    "button.save": "Kaydet",
    "button.import_data_from_selected_file": "Seçili dosyadan veri aktar",
    "parentalConsent.i_understand_that_the_participant_cannot": "9. Katılımcıların aday gösterdiği Ödül Merkezi'nde çalışmayan gönüllülerin, katılımcının faaliyetlerini gerçekleştirdiği bölüm için gerekli uzmanlığı olduğuna ya da bu faaliyetleri öğretmeye, bu faaliyetlerde gözetmen/denetmen olma niteliğine sahip olduğunu onaylayana ve bu kişilerin gerekli belgeleri Ödül Merkezi'ne teslim edinceye kadar katılımcının Ödül Programı'nın ilgili faaliyetine başlayamayacağını anlıyorum. ",
    "pageTitle.apiKeys": "",
    "label.international_region": "Uluslararası Bölge",
    "tabs.levels": "Kategoriler",
    "tabs.additional_files": "Ek Dosyalar",
    "label.continuation_level": "Devam eden katılımcı",
    "table.adventurous_journey_detail": "Macera ve Keşif Yolculuğu Detayları",
    "button.set": "Ayarla",
    "label.i_certify_that_as_the_assessor": "Bu faaliyet için katılımcının tüm şartları karşıladığını onaylıyorum.",
    "table.coordinator": "Ödül Koordinatörü",
    "participant.send_confirmation_email_again": "Tekrar onay emailini gönder?",
    "table.report": "Rapor",
    "label.update_translations_results": "Çeviri sonuçlarını güncelle",
    "table.observation_note": "Gözlem notları",
    "label.view_more": "Daha fazla göster",
    "notifications.payment_link_has_been_reset": "Ödeme linki güncellendi",
    "table.type": "Tür",
    "moduleTitle.updateConfigurationKey": "Yetki kodunu güncelle",
    "sidebar.independent_award_centers": "Bağımsız Ödül Merkezleri",
    "table.activity_type": "Faaliyet Türü",
    "label.awardMode.online": "Çevrimiçi",
    "table.data_state": "Son Veri Yenileme\n",
    "button.generate_report": "Rapor oluştur",
    "moduleTitle.assessed_by_award_leader": "Ödül Lideri tarafından değerlendirildi",
    "table.child_protection_number": "Çocuk koruma numarası",
    "button.bulk_change": "Toplu İşlem",
    "label.send_welcome_email": "Karşılama E-postası Gönder",
    "label.award_state": "Ödül Durumu",
    "moduleTitle.overview": "Genel Bakış",
    "table.aj_detail": "Macera ve Keşif Yolculuğu Detayları",
    "pageTitle.tasks_activity_approvals": "Faaliyet Onayı",
    "label.section": "Bölüm",
    "route.history": "Ödül Deneyimi",
    "route.event_participants": "Etkinlik Katılımcıları",
    "participant.account_detail": "Hesap Ayarları",
    "route.dashboard": "Pano",
    "table.payments": "Ödemeler",
    "pageTitle.profile": "Profil",
    "organisation.remove_organisation": "Kurumu Kaldır",
    "pageTitle.my_organization": "Bağlı Olduğum Kurum",
    "label.award_leader": "Ödül Lideri",
    "notifications.assessor_has_been_updated": "Danışman güncellendi",
    "label.participant_personal_reflection": "Katılımcının kişisel yansıması",
    "button.add_key": "anahtar ekle",
    "header.appMotto": "DUKE",
    "table.qualifying": "Asıl Yolculuk",
    "button.upload": "Yükle",
    "button.resend": "Tekrar gönder",
    "label.filename": "Dosya Adı",
    "label.change_parental_consent": "Belgeden elektroniğe ebeveyn onayı",
    "button.cancel": "İptal",
    "label.aply_to_all_langs": "Tüm dillere uygula",
    "route.customization": "Kişiselleştirme ",
    "errors.minimal_duration_is": "Minimum süre 30 dakikadır",
    "label.email_help_participant_first_name": "Katılımcının adı",
    "label.participant_status": "Katılımcının Durumu",
    "award.bronze_level_short": "Bronz",
    "label.phone_type": "Telefon Türü",
    "global.night": "gece",
    "button.adventurous_journey_settings": "Macera ve Keşif Yolculuğu Ayarları",
    "participant.leader_must_be_selected": "Bir Ödül Lideri seçilmeli",
    "pageTitle.translationsManagement": "Çeviri Yönetimi",
    "moduleTitle.user_added_preparation_and_training": "Kullanıcı Hazırlık ve Eğitim Ekledi",
    "table.approve": "Onayla",
    "label.role_in_organisation": "Kurumdaki Görevi",
    "states.finished": "Tamamlandı",
    "label.created": "Oluşturuldu",
    "button.back_to_home": "Ana Sayfaya Dön",
    "label.options": "Seçenekler",
    "contact.next_level_invitation": "Yeni kategori daveti",
    "moduleTitle.activity_detail": "Faaliyet Detayları",
    "route.section_signoff": "Bölüm Bitirme Onayı",
    "moduleTitle.assign_labels_bulk": "",
    "button.contact_settings": "Kişi Ayarları",
    "label.transation_id": "Ödeme İşlem No/ID",
    "notifications.activity_has_been_updated": "Faaliyet güncellendi",
    "sidebar.awards": "Ödüller",
    "parentalConsent.images_consent": "Ebeveyn olarak, resimlerin Uluslararası Ödül Vakfı tarafından tanıtım için kullanılmasına izin veriyorum. ",
    "participant.would_you_like_to_delete": "Bu hesabı silmek istiyor musunuz?",
    "roles.user": "İstatiksel",
    "label.label": "Etiket",
    "label.select_sheet": "Bilgisayarınızdan sayfa seçin",
    "global.no_results": "Sonuç Yok",
    "moduleTitle.address_line_2": "Adres (ikinci satır)",
    "states.awaiting_office_sign_off": "Ulusal Ofis Ödül Tamamlama Onayı bekleniyor",
    "moduleTitle.export": "Dışa Aktarma",
    "moduleTitle.address_line_1": "Adres (ilk satır)",
    "notifications.participant_has_been_assigned": "Katılımcının ataması yapıldı",
    "roles.viewer": "Görüntüleyici Kişi",
    "label.participants_total": "Tüm Katılımcılar",
    "errors.auth_code_is_no_longer_valid": "Yetki kodu geçerli değildir - daha önce kullanılmış ya da süresi dolmuş olabilir",
    "label.file_is_not_available": "Dosya bulunamıyor",
    "button.select_template": "Şablon Seç",
    "label.payment": "Ödeme",
    "award.silver_level_short": "Gümüş",
    "table.participant_id": "Katılımcı ID",
    "text.hours_old": "Saatlerce ",
    "moduleTitle.your_personal_information": "Kişisel Bilgileriniz",
    "aj.minimum_date_recommendation": "Deneme Yolculuğu için önerilen en kısa süre ve {name}  :",
    "label.date_of_payment": "Ödeme Tarihi",
    "button.view": "Görüntüle",
    "label.create_new_label": "Yeni etiket oluştur",
    "title.confirmation": "Onayla",
    "button.set_participants": "Katılımcıları Düzenle",
    "roles.assessor": "Danışman",
    "moduleTitle.coordinator_settings": "Koordinatör Ayarları",
    "label.parent_relationship": "Ebeveynlik&#39; ilişkisi",
    "table.nao": "Ulusal Ödül Otoritesi",
    "notifications.email_has_been_sent": "Email gönderildi",
    "label.email_help_participant_full_name": "Katılımcının tam adı",
    "sidebar.suboperating_authorities": "Operatör Otorite/Ortak",
    "route.award": "Ödül",
    "label.no_roles": "Rol yok",
    "table.files": "Dosyalar",
    "aj.minimum_date_requirements": "Asıl Yolculuk için gerekli olan minimum zaman ve {name}:",
    "pageTitle.labels": "Etiketler",
    "label.participant_is_semi_offline": "Katılımcı çevrimdışı",
    "moduleTitle.other_coordinators": "Diğer Koordinatörler",
    "button.updateSelectedLanguage": "Dil seçin",
    "tasks.approve_award_registration": "Ödül Kaydını Onayla",
    "participant.invite_participant_to_next_level": "Katılımcıyı yeni kategoriye davet et?",
    "label.twitter": "Twitter",
    "pageTitle.awards": "Ödülller",
    "warning.award_marked_as_paid": "Uyarı: Ücretli olarak işaretlenmiş en az bir Ödül seviyesi veya kayıt var. Onaylamadan önce lütfen ödeme ve geri ödeme yönergelerine bakın.",
    "table.edit": "Gözden geçir",
    "states.change_to_state_warning_missing_hours_to_complete": "UYARI: Gerekli minimum saat kaydedilmemiştir. Hala devam etmek istiyor musunuz?",
    "label.dofe": "Uluslararası Ödül Programı",
    "moduleTitle.after_assigning_a_role_to_yourself": "Kendiniz için bir görevi değiştirdikten veya atadıktan sonra, yeniden sisteme giriş yapmanız gerekmektedir.",
    "label.transaction_id": "İşlem No/ID",
    "table.suboperating_authority": "Alt Operasyon Otorite Birimi",
    "label.participant_survey": "Bir Ödül Programı Katılımcısı olarak Ödül Vakfı anketlerine mutlulukla katılırım",
    "label.created_by": "Oluşturan:",
    "button.send_confirmation_email_again_question": "Onay emailini tekrar gönder",
    "label.email_help_award_leader_email": "Ödül Liderinin e-postası",
    "label.name": "Ad",
    "tabs.gold_level": "Altın Kategorisi",
    "pageTitle.award_documents": "Ödül Belgeleri",
    "label.online_payments": "Online Ödeme",
    "label.child_protection_number": "Çocuk Koruma numarası",
    "participant.send_password_recovery_email": "Şifre yenileme emaili gönder?",
    "notifications.new_log_has_been_added": "Yeni faaliyet kaydı eklendi",
    "moduleTitle.add_gop_role": "",
    "label.organization_name": "Kurum İsmi",
    "pageTitle.my_organization_templates": "Bağlı Olduğum Kurum-Şablonlar",
    "pageTitle.award_leaders": "Ödül Liderleri",
    "label.status": "Durum",
    "label.street": "Sokak",
    "roles.if_staff_superuser": "Uluslararası Ödül Vakfı Superuser",
    "table.licence_holder": "Lisans Sahibi",
    "label.created_at": "Oluşturulan Yer: ",
    "table.section": "Bölüm",
    "table.system_rights": "Sistem Hakları",
    "label.iac_type": "Bağımsız Ödül Merkezi Türü",
    "label.other": "Diğer",
    "moduleTitle.login": "Giriş",
    "label.no_data_to_show": "Gösterilecek veri yok",
    "aj.cannot_modify_award_level_if_participants_are_assigned": "Katılımcı bir Macera ve Keşif yolculuğuna atanmışsa Ödül Kategorisini değiştiremezsiniz.",
    "tabs.waiting_payments": "Ödemeler bekleniyor",
    "global.supervisor": "Supervisor/ Gözetmen",
    "notifications.new_role_has_been_added": "Yeni görev eklendi",
    "award.silver_level": "Gümüş Kategorisi",
    "heading.change_awards_mode": "Ödül durumunu değiştir",
    "button.save_changes": "Değişiklikleri Kaydet",
    "organisation.would_you_like_to_move_award_unit": "Bu kurumu nereye taşımak istiyorsunuz?",
    "label.fields": "",
    "label.email_help_organization_name": "Ödül Merkezinin adı",
    "pageTitle.mro_related_detail": "EMAS Ofis- Detaylar",
    "table.started_at": "Başlanıgıç Zamanı:",
    "parentalConsent.i_consent_to_the_award_unit": "2. Ödül Merkezi çalışanlarını, Ödül Programı'nın uygulanmasında ve organizasyonun yapılmasında görev alan çalışanları ve diğer kişileri; gönüllüleri, şoförleri onaylıyorum. Ödül bölümlerinin gerektirdiği halde seyahat edilmesini onaylıyorum. Ödül Merkezi'nin olası bir seyahat durumunda beni önceden bilgilendireceğini biliyorum.",
    "logs.minutes": "dakika",
    "label.total_participants": "Tüm Katılımcılar",
    "moduleTitle.contact_info": "İletişim Bilgileri",
    "table.payment_link": "Ödeme linki",
    "errors.please_contact_your_local_award_staff": "Lütfen Ulusal Ofis ile iletişime geçiniz."
}